export default __webpack_public_path__ + "static/media/plataforma.00901813.png";